<ng-container *ngIf="store; else onlineStock">
    <ng-container
        *ngIf="
            (productStocks | storeStock: store) >= 0 && (productStocks | storeStockStatus: store) as stockStatus;
            else noStock
        "
    >
        <ng-container [ngTemplateOutlet]="stockDescription" [ngTemplateOutletContext]="{ stockStatus }" ></ng-container>
    </ng-container>
</ng-container>

<ng-template #stockDescription let-stockStatus="stockStatus">
    <app-stock-message [status]="stockStatus" [place]="store ? 'store' : 'online'" ></app-stock-message>
    <app-stock-status [status]="stockStatus"></app-stock-status>
</ng-template>

<ng-template #onlineStock>
    <ng-container [ngTemplateOutlet]="stockDescription" [ngTemplateOutletContext]="{ stockStatus }"></ng-container>
</ng-template>

<ng-template #noStock>
    {{ 'stock.unknownStockStatus' | translateSafe }}
</ng-template>
